export const CHANGE_LOCALE = 'CHANGE_LOCALE';

export const GET_SDS_LOCALE_OPTIONS = 'GET_SDS_LOCALE_OPTIONS';

export const SEARCH_QC_IN_PROGRESS = 'SEARCH_QC_IN_PROGRESS';

export const SEARCH_QC = 'SEARCH_QC';

export const SEARCH_QC_ERROR = 'SEARCH_QC_ERROR';

export const SEARCH_SDS_IN_PROGRESS = 'SEARCH_SDS_IN_PROGRESS';

export const SEARCH_SDS = 'SEARCH_SDS';

export const SEARCH_SDS_ERROR = 'SEARCH_SDS_ERROR';

export const DELETE_RECORD = 'DELETE_RECORD';

export const DELETE_ALL = 'DELETE_ALL';

export const GET_WWB = 'GET_WWB';

export const SEARCH_INTERNAL_SDS_IN_PROGRESS = 'SEARCH_INTERNAL_SDS_IN_PROGRESS';

export const SEARCH_INTERNAL_SDS = 'SEARCH_INTERNAL_SDS';

export const SEARCH_INTERNAL_SDS_ERROR = 'SEARCH_INTERNAL_SDS_ERROR';